import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=a4d7cd9c&scoped=true"
import script from "./EmailModal.vue?vue&type=script&lang=js"
export * from "./EmailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d7cd9c",
  null
  
)

export default component.exports